import styled from 'styled-components';

import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import DescriptionIcon from '@mui/icons-material/Description';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import UploadFileIcon from '@mui/icons-material/UploadFile';

export const StyledHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const StyledHeaderTitle = styled.div`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.h4.fontSize};
  line-height: ${({ theme }) => theme.typography.h4.lineHeight};
  font-weight: 600;
`;

export const StyledHeaderSubtitle = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  word-break: break-all;
`;

export const StyledHeaderUploadIcon = styled(UploadFileIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 28px;
`;

export const StyledHeaderDocIcon = styled(DescriptionIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 28px;
`;

export const StyledHeaderErrorIcon = styled(ErrorOutlineIcon)`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 28px;
`;

export const StyledProgressRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  margin-top: ${({ theme }) => theme.spacing(1.5)};
`;

export const StyledProgressMessage = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
`;

export const StyledCauseText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
  margin: 0;
`;

export const StyledField = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledFieldLabel = styled.p`
  color: ${({ theme }) => theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
  font-weight: 500;
  margin: 0 0 ${({ theme }) => theme.spacing(1)};
`;

export const StyledDropZone = styled.div<{ $dragOver: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(3, 2)};
  border: 1px dashed ${({ theme, $dragOver }) => ($dragOver ? theme.palette.primary.main : theme.palette.grey[400])};
  border-radius: 8px;
  background: ${({ theme, $dragOver }) => ($dragOver ? theme.tint.primary.subtle : 'transparent')};
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const StyledDropIcon = styled(CloudUploadOutlinedIcon)`
  color: ${({ theme }) => theme.palette.action.active};
`;

export const StyledDropCopy = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
`;

export const StyledChooseFileLink = styled.span`
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: underline;
`;

export const StyledDropHint = styled.div`
  color: ${({ theme }) => theme.palette.text.disabled};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  line-height: ${({ theme }) => theme.typography.caption.lineHeight};
`;

export const StyledDropError = styled.p`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  line-height: ${({ theme }) => theme.typography.caption.lineHeight};
  margin: ${({ theme }) => theme.spacing(0.5, 0, 0)};
`;

export const StyledChosenFile = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledChosenFileIcon = styled(DescriptionIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledChosenFileName = styled.span`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: ${({ theme }) => theme.typography.body1.lineHeight};
  font-weight: 500;
  flex: 1;
  text-align: left;
  word-break: break-all;
`;

// Visually hidden — `display: none` ignores programmatic .click() in some browsers.
export const StyledHiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;
